// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.DeleteButton {
    align-self: center;
    cursor: pointer
}

    .DeleteButton:hover {
        color: red;
    }*/
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/variable/variabledefinition.control.css"],"names":[],"mappings":"AAAA;;;;;;;MAOM","sourcesContent":["/*.DeleteButton {\n    align-self: center;\n    cursor: pointer\n}\n\n    .DeleteButton:hover {\n        color: red;\n    }*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
